// extracted by mini-css-extract-plugin
export default {"carousel-banner-group":"E6onq","carousel-swiper":"yO57G","carousel-dots":"aAVGX"};